"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "send-delegate-leader-spot" };
const _hoisted_2 = { class: "grid-delegates grid-in-send-delegate" };
const _hoisted_3 = { class: "count-in-send-delegate" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)('filterDiv party-container party-background--' + _ctx.partyNameToCss(_ctx.party.name) + _ctx.getUnavailablePartyClass())
    }, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)('board-party board-party--' + _ctx.partyNameToCss(_ctx.party.name))
        }, [
            (0, vue_1.createElementVNode)("div", {
                class: (0, vue_1.normalizeClass)(_ctx.getDominantClass())
            }, [
                (0, vue_1.createElementVNode)("div", _hoisted_1, [
                    (_ctx.party.partyLeader)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: 0,
                            class: (0, vue_1.normalizeClass)(['player-token', _ctx.party.partyLeader])
                        }, null, 2))
                        : (0, vue_1.createCommentVNode)("", true)
                ])
            ], 2),
            (0, vue_1.createElementVNode)("div", _hoisted_2, [
                ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(6, (n) => {
                    return (0, vue_1.createElementVNode)("div", {
                        class: "delegate-spot",
                        key: n
                    }, [
                        (_ctx.party.delegates.length >= n)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: 0,
                                class: (0, vue_1.normalizeClass)('player-token ' + _ctx.party.delegates[n - 1].color)
                            }, [
                                (0, vue_1.createElementVNode)("div", _hoisted_3, (0, vue_1.toDisplayString)(_ctx.party.delegates[n - 1].number), 1)
                            ], 2))
                            : (0, vue_1.createCommentVNode)("", true)
                    ]);
                }), 64))
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                class: (0, vue_1.normalizeClass)('selectable-party-name party-name party-name--' + _ctx.partyNameToCss(_ctx.party.name))
            }, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.party.name), 1)
            ], 2)), [
                [_directive_i18n]
            ])
        ], 2)
    ], 2));
}
